// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-splash-view {
  background-color: rgb(54, 47, 65);
  height: 100%;
  position: relative;
  width: 100%;
}

.simx-splash-view--branding-container {
  align-items: center;
  display: flex;
  flex-direction: column;
  left: 50%;
  padding: 50px;
  position: fixed;
  transform: translateX(-50%);
  -webkit-user-select: none;
          user-select: none;
}
@media only screen and (min-width: 1024px) {
  .simx-splash-view--branding-container {
    align-items: flex-start;
    bottom: 0;
    padding: 100px 10% 110px 10%;
    width: 100%;
  }
}

.simx-splash-view--logo {
  display: block;
  width: 250px;
  height: auto;
  transition: width 0.2s;
}
@media only screen and (min-width: 650px) {
  .simx-splash-view--logo {
    width: 325px;
  }
}
@media only screen and (min-width: 800px) {
  .simx-splash-view--logo {
    width: 400px;
  }
}
@media only screen and (min-width: 1024px) {
  .simx-splash-view--logo {
    width: 400px;
  }
}

.simx-splash-view--app-name {
  color: rgba(255, 255, 255, 0.95);
  font-family: "Quicksand";
  font-size: 40px;
  font-weight: 600;
  line-height: 1.1;
  margin: 0.5em 0 0 0;
  padding: 0;
  position: relative;
  text-align: center;
  transition: font-size 0.2s;
  white-space: nowrap;
  width: 100%;
}
@media only screen and (min-width: 650px) {
  .simx-splash-view--app-name {
    font-size: 45px;
  }
}
@media only screen and (min-width: 800px) {
  .simx-splash-view--app-name {
    font-size: 50px;
  }
}
@media only screen and (min-width: 1024px) {
  .simx-splash-view--app-name {
    font-size: 55px;
    text-align: left;
  }
  .simx-splash-view--app-name::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -15px;
    width: 100%;
    height: 3px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.simx-splash-view--child-view-area {
  align-items: flex-start;
  display: flex;
  height: 100%;
  justify-content: center;
  padding-top: 272px;
  padding-bottom: 5%;
  padding-left: 10%;
  padding-right: 10%;
  position: relative;
  transition: padding 0.2s;
  width: 100%;
}
@media only screen and (min-width: 650px) {
  .simx-splash-view--child-view-area {
    padding-top: 312px;
  }
}
@media only screen and (min-width: 800px) {
  .simx-splash-view--child-view-area {
    padding-top: 352px;
  }
}
@media only screen and (min-width: 1024px) {
  .simx-splash-view--child-view-area {
    height: calc(100vh - 320px);
    justify-content: flex-end;
    min-height: 700px;
    padding-top: 80px;
    padding-bottom: 80px;
  }
}

.simx-splash-view--child-view-container {
  background-color: rgb(214.9328484848, 213.1985454545, 218.4014545455);
  border-radius: 4px;
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  max-height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/core/components/splash-view/splash-view.component.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAGA;EACE,iCCD8B;EDE9B,YAAA;EACA,kBAAA;EACA,WAAA;AAFF;;AAKA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AAFF;AAIE;EAVF;IAWI,uBAAA;IACA,SAAA;IACA,4BAAA;IACA,WAAA;EADF;AACF;;AAIA;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AADF;AAGE;EANF;IAOI,YAAA;EAAF;AACF;AACE;EATF;IAUI,YAAA;EAEF;AACF;AADE;EAZF;IAaI,YAAA;EAIF;AACF;;AADA;EACE,gCC1B8B;ED2B9B,wBE9CgB;EF+ChB,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AAIF;AAFE;EAdF;IAeI,eAAA;EAKF;AACF;AAJE;EAjBF;IAkBI,eAAA;EAOF;AACF;AANE;EApBF;IAqBI,eAAA;IACA,gBAAA;EASF;EARE;IACE,WAAA;IACA,kBAAA;IACA,OAAA;IACA,aAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,0CAAA;EAUJ;AACF;;AANA;EACE,uBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;AASF;AAPE;EAbF;IAcI,kBAAA;EAUF;AACF;AATE;EAhBF;IAiBI,kBAAA;EAYF;AACF;AAXE;EAnBF;IAoBI,2BAAA;IACA,yBAAA;IACA,iBAAA;IACA,iBAAA;IACA,oBAAA;EAcF;AACF;;AAXA;EACE,qECpG8B;EDqG9B,kBAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;AAcF","sourcesContent":["@use 'colors';\n@use 'fonts';\n\n.simx-splash-view {\n  background-color: colors.$simxColorDarkAccent;\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n\n.simx-splash-view--branding-container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  left: 50%;\n  padding: 50px;\n  position: fixed;\n  transform: translateX(-50%);\n  user-select: none;\n\n  @media only screen and (min-width: 1024px) {\n    align-items: flex-start;\n    bottom: 0;\n    padding: 100px 10% 110px 10%;\n    width: 100%;\n  }\n}\n\n.simx-splash-view--logo {\n  display: block;\n  width: 250px;\n  height: auto;\n  transition: width 0.2s;\n\n  @media only screen and (min-width: 650px) {\n    width: 325px;\n  }\n  @media only screen and (min-width: 800px) {\n    width: 400px;\n  }\n  @media only screen and (min-width: 1024px) {\n    width: 400px;\n  }\n}\n\n.simx-splash-view--app-name {\n  color: colors.$simxColorTextInvert;\n  font-family: fonts.$simxFontGraphic;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 1.1;\n  margin: 0.5em 0 0 0;\n  padding: 0;\n  position: relative;\n  text-align: center;\n  transition: font-size 0.2s;\n  white-space: nowrap;\n  width: 100%;\n\n  @media only screen and (min-width: 650px) {\n    font-size: 45px;\n  }\n  @media only screen and (min-width: 800px) {\n    font-size: 50px;\n  }\n  @media only screen and (min-width: 1024px) {\n    font-size: 55px;\n    text-align: left;\n    &::after {\n      content: '';\n      position: absolute;\n      left: 0;\n      bottom: -15px;\n      width: 100%;\n      height: 3px;\n      border-radius: 4px;\n      background-color: rgba(255, 255, 255, 0.1);\n    }\n  }\n}\n\n.simx-splash-view--child-view-area {\n  align-items: flex-start;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  padding-top: 272px;\n  padding-bottom: 5%;\n  padding-left: 10%;\n  padding-right: 10%;\n  position: relative;\n  transition: padding 0.2s;\n  width: 100%;\n\n  @media only screen and (min-width: 650px) {\n    padding-top: 312px;\n  }\n  @media only screen and (min-width: 800px) {\n    padding-top: 352px;\n  }\n  @media only screen and (min-width: 1024px) {\n    height: calc(100vh - 320px);\n    justify-content: flex-end;\n    min-height: 700px;\n    padding-top: 80px;\n    padding-bottom: 80px;\n  }\n}\n\n.simx-splash-view--child-view-container {\n  background-color: colors.$simxColorDarkNeutralLight;\n  border-radius: 4px;\n  box-shadow: 0 0 50px 0 rgba(0,0,0,0.5);\n  display: flex;\n  max-height: 100%;\n}\n","@use 'sass:color';\n\n$simxColorBrightAccent:         rgb(229, 0, 44);  // Red\n$simxColorDarkAccent:           rgb(54, 47, 65);  // Purple\n$simxColorBrightGreen:          rgb(0, 201, 133);\n$simxColorMustard:              rgb(255, 177, 0);\n\n$simxColorDarkAccentMedium:     color.adjust($simxColorDarkAccent, $lightness: 6%);\n$simxColorDarkAccentLight:      color.adjust($simxColorDarkAccent, $lightness: 53%);\n$simxColorDarkNeutral:          rgb(21, 19, 25);\n$simxColorDarkNeutralLight:     color.adjust(color.adjust($simxColorDarkNeutral, $saturation: -7%), $lightness: 76%);\n$simxColorLightNeutral:         rgb(230, 235, 235);\n$simxColorLightNeutralLight:    color.adjust($simxColorLightNeutral, $lightness: 5%);\n$simxColorLightNeutralDark:     color.adjust($simxColorLightNeutral, $lightness: -12.5%);\n$simxColorLightNeutralDarker:   color.adjust($simxColorLightNeutral, $lightness: -25%);\n$simxColorLightNeutralDarkest:  color.adjust($simxColorLightNeutral, $lightness: -37.5%);\n$simxColorWhite:                rgb(255, 255, 255);\n\n$simxColorTextDefault:          $simxColorDarkNeutral;\n$simxColorTextLight:            rgb(166, 167, 169);\n$simxColorTextInvert:           rgba(255, 255, 255, 0.95);\n$simxColorTextOverDarkAccent:   rgba($simxColorWhite, 0.95);\n\n$simxColorControlBackground:    $simxColorWhite;\n$simxColorControlBorder:        $simxColorLightNeutralDark;\n","$simxFontDefault: 'Open Sans';\n$simxFontGraphic: 'Quicksand';\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
